import { CheckCircle2, Mail, Slack, XCircle } from "lucide-react";
import { relTime } from "@/lib/format";
import { cn } from "@/lib/utils";

function HealthRow({ icon: Icon, title, ok, detail, checked, testId }) {
  return (
    <div className={cn("flex items-center gap-3 px-3 py-2 rounded border bg-[#0f172a] min-w-0", ok == null ? "border-[#1f293d]" : ok ? "border-emerald-500/30" : "border-red-500/40")} data-testid={testId}>
      <Icon className={cn("h-4 w-4 shrink-0", ok == null ? "text-slate-500" : ok ? "text-emerald-300" : "text-red-300")} />
      <div className="min-w-0 flex-1">
        <div className="text-xs font-semibold text-slate-100 flex items-center gap-1.5">{title} {ok == null ? null : ok ? <CheckCircle2 className="h-3 w-3 text-emerald-400" /> : <XCircle className="h-3 w-3 text-red-400" />}</div>
        <div className={cn("text-[11px] truncate", ok === false ? "text-red-300" : "text-slate-500")} title={detail}>{detail}</div>
      </div>
      <span className="hidden sm:inline text-[10px] font-mono text-slate-500 whitespace-nowrap">{checked ? `checked ${relTime(checked)}` : "not checked yet"}</span>
    </div>
  );
}

export function DeliveryHealth({ health }) {
  const r = health?.resend;
  const s = health?.slack;
  const resendDetail = !r ? "Hourly ping of the Resend API and sender-domain verification" : r.ok ? `Resend reachable · domain ${r.domain} ${r.domain_status || "found"}${r.latency_ms != null ? ` · ${r.latency_ms} ms` : ""}` : r.error;
  const slackDetail = !s ? "Hourly check of the Slack bot token (webhooks reflect the last real post)" : s.ok ? `${s.mode} mode OK${s.team ? ` · ${s.team}` : ""}${s.last_success_at ? ` · last post ${relTime(s.last_success_at)}` : ""}` : s.error || "Not configured";
  return (
    <div className="grid sm:grid-cols-2 gap-2 min-w-0" data-testid="delivery-health">
      <HealthRow testId="delivery-health-resend" icon={Mail} title="Resend (email)" ok={r ? r.ok : null} detail={resendDetail} checked={r?.checked_at} />
      <HealthRow testId="delivery-health-slack" icon={Slack} title="Slack" ok={s ? (s.mode ? s.ok : null) : null} detail={slackDetail} checked={s?.checked_at} />
    </div>
  );
}
